/**
 * File System Utilities - Public Interface
 *
 * This module exports file system utilities used across domains.
 * Wraps fs-extra to provide a consistent, domain-friendly interface.
 */

export * from './file-writer';
export * from './file-reader';
